import { useMutation } from '@tanstack/react-query';
import { openAccountMargin } from '../requests';
import type { OpenAccountResponseDto } from '../types';

interface UseOpenAccountMarginOptions {
  onSuccess?: (data: OpenAccountResponseDto) => void;
}

const useOpenAccountMargin = (options?: UseOpenAccountMarginOptions) => {
  const mutation = useMutation({
    mutationFn: openAccountMargin,
    onSuccess: options?.onSuccess,
  });

  return {
    openAccount: mutation.mutateAsync,
    isOpenAccountPending: mutation.isPending,
    isOpenAccountSuccess: mutation.isSuccess,
    isOpenAccountError: mutation.isError,
    openAccountData: mutation.data,
    openAccountError: mutation.error,
  };
};

export { useOpenAccountMargin };
